import { useDropzone, type DropzoneState } from "react-dropzone";
import { ActorRefFrom } from "xstate";
import {
  acceptedExtensions,
  acceptedGeometryFiles,
} from "../utils/fileAcceptance";
import { GeometryMachineContext } from "../state/geometryMachine";

export function useGeometryDropzone(
  geometryMachine?: ActorRefFrom<typeof GeometryMachineContext.machine>
): DropzoneState {
  const defaultGeometryMachine = GeometryMachineContext.useActorRef();
  const machine = geometryMachine || defaultGeometryMachine;

  return useDropzone({
    accept: acceptedExtensions.geometry,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;

      machine.send({
        type: "ADD_FILES",
        files: acceptedGeometryFiles(acceptedFiles),
      });
    },
  });
}
